import { render, staticRenderFns } from "./webHead.vue?vue&type=template&id=c2052a42&scoped=true"
import script from "./webHead.vue?vue&type=script&lang=js"
export * from "./webHead.vue?vue&type=script&lang=js"
import style0 from "./webHead.vue?vue&type=style&index=0&id=c2052a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2052a42",
  null
  
)

export default component.exports